export default "__VITE_ASSET__887867d0__"